import React, {useMemo} from "react";
import {PageHeading} from "peggirkit";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import {useIntl} from "react-intl";
import {generateBreadcrumbs} from "@widgets/layout/Breadcrumbs";
import AccountSettings from "@widgets/account/AccountSettings";


const Account = () => {
    const intl = useIntl();
    const route: Route = useMemo(() => router.account, []);

    return (
        <AdminLayout currentPage={route}>
            <PageHeading
                breadcrumbs={generateBreadcrumbs(route, intl)}
                title={route.name(intl)}
            />

            <AccountSettings/>
        </AdminLayout>
    );
};

export default Account;